import { useContext, useMemo } from "react";
import { 
  AddSubtaskListInput, 
  ListActionCable, 
  ListHook, 
  SubtaskList 
} from "./";
import { useDispatch, useSelector } from "react-redux";
import { ContentGroupContext } from "../../providers/ContentGroupProvider";
import { handleDragEndList } from "../../handlers/handleDragEndList";
import { DragDropContext, Droppable } from "react-beautiful-dnd";

function SubtaskSection({
  readOnly = false
}) {
  const dispatch = useDispatch();
  const { workspace_id, content_group_id } = useContext(ContentGroupContext);
  const lists = useSelector(state => state.list.lists);
  const can_create = useSelector(state => state.list.can_create);
  const can_show = useSelector(state => state.list.can_show);

  const filterList = useMemo(() => {
    if (can_show) {
      return lists;
    }
    return lists.filter((list) => list.hidden === false);
  }, [lists, can_show]);

  const onDragEnd = (result) => {
    handleDragEndList({
      result, 
      workspace_id,
      content_group_id,
      lists: filterList,
      dispatch, 
    });
  }

  return (
    <div 
      className="subtask-section py-3"
      id={'subtaskSection'}
    >
      <ListActionCable />
      <ListHook 
        workspace_id={workspace_id} 
        content_group_id={content_group_id}
      /> 
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="subtask-lists" type="LIST">
          {(provided) => (
            <div 
              {...provided.droppableProps} 
              ref={provided.innerRef}
            >
              {
                lists && (
                  filterList.map((list, index) => (
                      <SubtaskList 
                        list={list} 
                        key={list.id} 
                        index={index}
                        readOnly={readOnly}
                      />
                  ))
                )
              }
              {provided.placeholder}
            </div>    
          )}
        </Droppable>
      </DragDropContext>

      {
        can_create && readOnly === false &&
        <AddSubtaskListInput />
      }
    </div>
  );
}

export { SubtaskSection };
